var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeDisable18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.35 11.44a2.94 2.94 0 0 0 4.06-4.1l-.8.8A1.85 1.85 0 0 1 9 10.85c-.3 0-.6-.07-.85-.2l-.8.8Zm6.47-6.53c1.06.98 1.96 2.3 2.64 3.87.05.14.05.3 0 .44-1.57 3.67-4.36 5.87-7.46 5.87a6.8 6.8 0 0 1-3.97-1.31l-1.42 1.43a.54.54 0 0 1-.38.16.55.55 0 0 1-.45-.86l.01-.02L13.62 3.57c.01-.02.03-.03.03-.05l.04-.04.69-.7a.55.55 0 0 1 .77 0c.22.22.22.57 0 .79L13.82 4.9Zm-7.75 4.1c0 .19.03.38.05.56l-2.7 2.73a11.87 11.87 0 0 1-1.88-3.08.56.56 0 0 1 0-.44C3.11 5.11 5.9 2.91 9 2.91H9c1.05 0 2.06.26 3 .73L9.56 6.1A2.94 2.94 0 0 0 6.08 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisable18);
export default __webpack_public_path__ + "static/media/eye-disable-18.017448d2a36eb036a2ba7578fd12a005.svg";
export { ForwardRef as ReactComponent };